import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const profileApiSlice = createApi({
  reducerPath: 'ProfileApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getUsers: builder.query({
    query: () => '/profiles/all',
    }),
  }),
});

export const { useGetProfilesQuery } = profileApiSlice;
